<router-outlet style="z-index: -1;" ></router-outlet>

<app-loader></app-loader>
<!-- <div class="col-12 p-4 mt-1" style="background-color:#01152B; position: absolute; left: 0;">
</div> -->

